import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { TrainingLevel } from './model/training-level.model';
import { Action, createReducer, on } from '@ngrx/store';
import { TrainingLevelActions } from './trainingLevel.actions';

export const trainingLevelFeatureKey = 'trainingLevel';

export const trainingLevelAdapter = createEntityAdapter<TrainingLevel>();

export interface State extends EntityState<TrainingLevel> {}

export const initialState: State = trainingLevelAdapter.getInitialState({});

const trainingLevelReducer = createReducer(
    initialState,
    on(TrainingLevelActions.loadTrainingLevelSuccess, (state, { trainingLevels }) => trainingLevelAdapter.addMany(trainingLevels, state))
);

export function reducer(state: State | undefined, action: Action) {
    return trainingLevelReducer(state, action);
}
